export default __webpack_public_path__ + "static/media/fast-icon.c516677d.svg";